export const styles = {
    root: {
        w: "full",
    },
    header: {
        gap: 2,
        flexDirection: "column" as const,
    },
    headerGridLayout: {
        mb: "32px",
    },
    headerDefault: {
        mb: 4,
    },
    title: {
        fontWeight: "bold",
    },
    description: {
        fontSize: "16px",
        lineHeight: "24px",
        w: { base: "full", lg: "50%" },
    },
    tiles: {
        display: { base: "flex", xl: "grid" },
        flexDirection: "column" as const,
        alignItems: "stretch" as const,
        gap: "24px",
        w: "full",
        gridAutoRows: "1fr",
        "& > *": {
            h: "100%",
            minH: 0,
            display: "flex",
            flexDirection: "column",
        },
    },
};
